import { Component, OnInit } from '@angular/core';
import { NoEmpidService } from 'app/services/no-empid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SickLeaveListService } from 'app/services/sick-leave-list.service';

@Component({
  selector: 'app-no-empid-list',
  templateUrl: './no-empid-list.component.html',
  styleUrls: ['./no-empid-list.component.css']
})
export class NoEmpidListComponent implements OnInit {

  public p;
  public filterLeaveListTerm = "";
  public isDesc;
  public column;
  public direction;
  public noEmpidListFlag: any;
  public groupFilterValue;
  public hrStatusFilterList = [
    'To be checked (no Emplid)',
    'On Hold',
    'No ID Possible'
  ];
  // 'Identified',
  public filterString = '';
  public filterObject = {
    hrStatus: []
  };
  public certWithNoEmpidList = [];
  public hrFilterFlag: boolean;
  public totalCount: number;
  public hrUnjustifiedCount: number;

  constructor(private noEmpidService: NoEmpidService, private router: Router, private sickLeaveListService: SickLeaveListService) {

  }

  ngOnInit() {
    this.hrFilterFlag = true;
    this.totalCount = 0;
    this.hrUnjustifiedCount = 0;
    this.getCertListWithoutEmpid();
    if (sessionStorage.getItem('nelgf') === null || sessionStorage.getItem('nelgf') === '') {
      sessionStorage.setItem('nelgf', '');
    } else {
      this.filterObject = JSON.parse(sessionStorage.getItem('nelgf'));
      this.filterString = this.filterToString();
    }
  }

  sortBy(property: string) {
    this.isDesc = !this.isDesc;
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  getCertListWithoutEmpid() {
    this.noEmpidService.getCertListWithNoEmpid()
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.certWithNoEmpidList = res.response.absences;
            this.noEmpidListFlag = true;
            this.totalCount = this.certWithNoEmpidList.length;
            this.certWithNoEmpidList.forEach(element => {

              if (element.statushradmin === 'To be cheched') {
                this.hrUnjustifiedCount += 1;
              }
            });
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.certWithNoEmpidList = [];
          this.noEmpidListFlag = true;
        });
  }

  processFilterObject(array, itemValue) {
    if (itemValue !== null && itemValue.trim() !== '') {
      if (array.indexOf(itemValue) !== -1) {
        array.splice(array.indexOf(itemValue), 1);
        return array;
      }
      else {
        array.push(itemValue);
        return array;
      }
    }
    return array;
  }

  updateList(itemValue, type) {
    let temp = [];
    if (type === 'hradmin') {
      temp = this.processFilterObject(this.filterObject.hrStatus, itemValue);
      this.filterObject.hrStatus = temp;
    }
    sessionStorage.setItem('nelgf', JSON.stringify(this.filterObject));
    this.filterString = this.filterToString();
  }

  filterToString() {
    return this.filterObject.hrStatus.toString();
  }

  toCertificateWithoutEmpidView(item) {
    localStorage.setItem('certAddon', JSON.stringify(item));
    this.router.navigate(['nel/noEmpidCertView', item.certificateid]);
  }

}



// WEBPACK FOOTER //
// ./src/app/no-empid-list/no-empid-list.component.ts